import { render, staticRenderFns } from "./renewEdit.vue?vue&type=template&id=2218444e&scoped=true&"
import script from "./renewEdit.vue?vue&type=script&lang=js&"
export * from "./renewEdit.vue?vue&type=script&lang=js&"
import style0 from "./renewEdit.vue?vue&type=style&index=0&id=2218444e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2218444e",
  null
  
)

export default component.exports